import React, { memo } from 'react';
export function Tomos() {
  const tomos = [{
    number: 1,
    title: 'Consulta clínica efectiva',
    description: 'Entrevista inicial, anamnesis, motivo de consulta, objetivos, consentimiento informado, registro de sesión, modelo de devolución a familias.'
  }, {
    number: 2,
    title: 'Intervención psicopedagógica',
    description: 'Planificación por objetivos, banco de estrategias, seguimiento, registro de evolución, propuestas por áreas (atención, memoria, funciones ejecutivas, lenguaje).'
  }, {
    number: 3,
    title: 'Evaluación inteligente',
    description: 'Screening, indicadores observables, listas de cotejo, instrumentos simples, informes editables, devolución clara, semáforos de alerta.'
  }, {
    number: 4,
    title: 'Lectoescritura desde cero',
    description: 'Conciencia fonológica, trazos, grafomotricidad, secuencias de actividades, fichas imprimibles, progresiones por niveles.'
  }, {
    number: 5,
    title: 'Proceso de alfabetización',
    description: 'Etapas, estrategias, actividades graduadas, apoyo para dificultades frecuentes, recursos por semana, registro de avances.'
  }, {
    number: 6,
    title: 'Juegos terapéuticos',
    description: 'Juegos por objetivo (autorregulación, habilidades sociales, atención, lenguaje), fichas de juego, variantes, materiales imprimibles.'
  }];
  return <section className="w-full py-16 bg-[#111111] font-['Open_Sans',_sans-serif] pt-[0px] pb-[0px]" data-id="element-261">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-262">
        <div className="text-center mb-12" data-id="element-263">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-264">
            Lo que recibís
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-[500]" data-id="element-265">
            Material listo para usar para organizar evaluación e intervención
            durante todo el año.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-10 border border-[#D4A843]/25 rounded-2xl p-6 md:p-8" data-id="element-266">
          <div className="space-y-4" data-id="element-267">
            {tomos.map(tomo => <div key={tomo.number} className="flex items-start gap-4" data-id="element-268">
                <div className="bg-[#D4A843] w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0 text-white shadow-[0_0_10px_rgba(212,168,67,0.3)] mt-0.5" data-id="element-269">
                  {tomo.number}
                </div>
                <div data-id="element-270">
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-271">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-400 text-sm mt-1 leading-relaxed" data-id="element-272">
                    {tomo.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="flex justify-center" data-id="element-273">
          <a href="#ofertas" className="inline-block bg-[#D4A843] hover:bg-[#B8912E] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 text-[16px] shadow-[0_0_20px_rgba(212,168,67,0.2)]" data-id="element-274">
            🧮→ Quiero el Megapack
          </a>
        </div>
      </div>
    </section>;
}